import { render, staticRenderFns } from "./SelfSkillInfo.vue?vue&type=template&id=9b282198&"
import script from "./SelfSkillInfo.vue?vue&type=script&lang=js&"
export * from "./SelfSkillInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports